import PrimaryHeader from '@/components/PrimaryHeader';
import Section from '@/components/Section';
import Images from '@/constants/Images';
import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import logoImage from '../../../assets/images/logo_square.png';
import AnnouncementBanner from '../AnnouncementBanner';
import OptionCard from '../my-network/OptionCard';
import GetInvolved from './GetInvolved';
import Involvement from './Involvement';
import NeedsAttention from './NeedsAttention';
import RecentMessages from './RecentMessages';

function Header(props) {
  const { currentUser, children } = props;

  return (
    <div>
      <Helmet>
        <title>Home</title>
      </Helmet>
      <PrimaryHeader
        style="simple"
        title={(
          <div className="text-4xl font-semibold text-cs-gray-900 space-x-4">
            <span>{`Welcome back${currentUser.data.firstName ? `, ${currentUser.data.firstName}!` : '!'}`}</span>
            <span>🎉</span>
          </div>
        )}
        textClassName="text-cs-orange-500"
      />
      <AnnouncementBanner/>
      <div className="px-4 mb-24 w-full lg:mx-auto">
        <Section className="space-y-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3x gap-4">
            <OptionCard
              centeredImage={(
                <img className="h-24 w-24" src={logoImage} alt="Logo"/>
              )}
              title="Create and launch activities"
              subtitle="Start a new project, event, or offer. We'll help every step of the way!"
              linkText="Create"
              to="/my-leading"
            />
            <OptionCard
              imageUrl={Images.FIND_SUPPORT_RESOURCES}
              title="Find support and resources"
              subtitle="Get in touch with your local support team, find tools to get started, and more!"
              linkText="Get support"
              to="/my-network"
            />
          </div>
          {children}
        </Section>
      </div>
    </div>
  );
}

Header.propTypes = {
  currentUser: PropTypes.object.isRequired,
  children: PropTypes.node,
};

export default function LegacyLayout(props) {
  const { currentUser } = props;
  return (
    <Header currentUser={currentUser}>
      <NeedsAttention/>
      <Involvement/>
      <GetInvolved/>
      <RecentMessages/>
    </Header>
  );
}

LegacyLayout.propTypes = {
  currentUser: PropTypes.object.isRequired,
};
